import gql from 'graphql-tag';

import { PhotoThumbnails } from '../../../../../graphql/fragments/album';

export const PhotoForFaceTag = gql`
  query photoForFaceTag($id: RecordID!, $albumIds: [RecordID] = []) {
    photo(id: $id) {
      id
      ...PhotoThumbnails
      faces(
        slice: { limit: 999 }
        exclude_machine_labeled_pub_boxes: true
        exclude_human_labeled_pub_boxes: false
        owned_only_human_labeled_pub_boxes: true
      ) {
        records {
          id
          facebox
          has_human_votes
          faux_face_type
          is_creator
          matched_photos(slice: { limit: 1 }, album_ids: $albumIds) {
            records {
              id
              identity {
                id
                name
                last_name
                current_face {
                  id
                }
                current_matching_face {
                  id
                }
                current_photo {
                  ...PhotoThumbnails
                }
                current_matching_photo {
                  ...PhotoThumbnails
                }
                account_identity_name {
                  id
                  name
                  last_name
                }
              }
            }
          }
        }
      }
    }
  }
  ${PhotoThumbnails}
`;

export const AlbumSelectedIdentitiesForFaceTagging = gql`
  query albumSelectedIdentitiesForFaceTagging(
    $id: RecordID!
    $limit: Int = 10
    $offset: Int = 0
    $searchQuery: String
  ) {
    album(id: $id) {
      id
      selected_identities(
        slice: { limit: $limit, offset: $offset }
        search_query: $searchQuery
        unique_roster_identities: true
        without_invitees: true
      ) {
        total
        records {
          id
          identity {
            id
            name
            last_name
            current_matching_photo {
              ...PhotoThumbnails
            }
            current_photo {
              ...PhotoThumbnails
            }
            current_matching_face {
              id
            }
            current_face {
              id
            }
            account {
              id
              name
              phone_number
            }
            account_identity_name {
              id
              name
              last_name
            }
          }
          claimed
        }
      }
    }
  }
  ${PhotoThumbnails}
`;
